export default "__VITE_ASSET__0MCeBpC5__"